export const SystemLanguages = [
  { value: "nl", label: "nl", id: 1 },
  { value: "en", label: "en", id: 2 },
  { value: "tr", label: "tr", id: 3 },
  { value: "ar", label: "ar", id: 4 },
  { value: "es", label: "es", id: 5 },
  { value: "de", label: "de", id: 6 },
  { value: "fr", label: "fr", id: 7 },
  { value: "pl", label: "pl", id: 8 },
  { value: "ru", label: "ru", id: 9 },
  { value: "zh", label: "zh", id: 10 },
  { value: "it", label: "it", id: 11 },
  { value: "pa", label: "pa", id: 12 },
  { value: "hi", label: "hi", id: 13 },
  { value: "ur", label: "ur", id: 14 },
  { value: "sr", label: "sr", id: 15 },
  { value: "ja", label: "ja", id: 16 },
  { value: "ko", label: "ko", id: 17 },
];
